import colors from '@constants/colors';
import { portalTasksPriorities } from '@constants/common';

export const getCellColor = (name: string) => {
	switch (true) {
		case name === portalTasksPriorities.high:
			return colors.red50;

		case name === portalTasksPriorities.medium:
			return colors.orange50;

		case name === portalTasksPriorities.low:
			return colors.green60;

		default:
			return;
	}
};
